import React, { useEffect, useState } from 'react';
import RadioList, { FilterListItem } from '../RadioList';
import { FieldValues, Path } from 'react-hook-form';
import { dispatchService } from '../../../services/central-api/dispatch';

function ActingBodyList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getActingBodies() {
        try {
            setIsLoading(true);
            const actingBodies = await dispatchService.getActingBodies();
            setItems(actingBodies.map((actingBody) => {
                return {
                    value: actingBody.id,
                    label: actingBody.name
                };
            }));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getActingBodies();
    }, []);

    return <RadioList items={items} name={name} clearValue={null} isLoading={isLoading} />;
}

ActingBodyList.getCount = RadioList.getCount;

export default ActingBodyList;
